import { render, staticRenderFns } from "./SubUnitNew.vue?vue&type=template&id=779a9306&scoped=true&"
import script from "./SubUnitNew.vue?vue&type=script&lang=ts&"
export * from "./SubUnitNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779a9306",
  null
  
)

export default component.exports